import { delay, put, takeLatest } from "redux-saga/effects";
import { mockQuotes, quotesActions } from "./slice";

function* getQuotesListSaga() {
  try {
    yield delay(200);
    yield put(quotesActions.getQuotesListSuccess(mockQuotes));
  } catch (error) {
    yield put(quotesActions.getQuotesListFailed("Failed to load quotes"));
  }
}

function* getQuoteDetailsSaga(
  action: ReturnType<typeof quotesActions.getQuoteDetails>
) {
  try {
    yield delay(200);

    const quote = mockQuotes.find((item) => item.id === action.payload);

    if (!quote) {
      yield put(quotesActions.getQuoteDetailsFailed("Quote not found"));
      return;
    }

    yield put(quotesActions.getQuoteDetailsSuccess(quote));
  } catch (error) {
    yield put(quotesActions.getQuoteDetailsFailed("Failed to load quote"));
  }
}

export function* quotesSaga() {
  yield takeLatest(quotesActions.getQuotesList.type, getQuotesListSaga);
  yield takeLatest(quotesActions.getQuoteDetails.type, getQuoteDetailsSaga);
}